import { api } from './api';

export const documents = api.injectEndpoints({
  endpoints: builder => ({
    getDocuments: builder.query({
      query: () => {
        return {
          url: `/documents/general/`,
        };
      },
      providesTags: [{ type: 'Documents', id: 'LIST' }],
      keepUnusedDataFor: 5,
    }),
    getTripDocuments: builder.query({
      query: (tripId: number | string) => {
        return {
          url: `trips/documents/trip/${tripId}/`,
        };
      },
      providesTags: (result, _err, tripId) => [{ type: 'TripDocuments', id: String(tripId) }],
      keepUnusedDataFor: 5,
    }),
    getStopDocuments: builder.query({
      query: (tripStopId: number | string) => {
        return {
          url: `trips/documents/stop/${tripStopId}/`,
        };
      },
      providesTags: (result, _err, tripStopId) => [{ type: 'TripDocuments', id: `stop-${String(tripStopId)}` }],
      keepUnusedDataFor: 5,
    }),
    addDocument: builder.mutation({
      query: formData => ({
        url: `trips/documents/add/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Trip'],
    }),
    addStopDocument: builder.mutation({
      query: formData => ({
        url: `trips/documents/stop/add/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (_result, _error, formData) => {
        const tripStopId = formData?.get?.('trip_stop');
        if (tripStopId) {
          return ['Trip', { type: 'TripDocuments', id: `stop-${String(tripStopId)}` }];
        }
        return ['Trip'];
      },
    }),
    updateDocument: builder.mutation({
      query: ({ id, formData }) => ({
        url: `trips/documents/${id}/`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['Trip'],
    }),
    deleteDocumet: builder.mutation({
      query: ({ id }) => ({
        url: `trips/documents/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Trip'],
    }),
  }),
});

export const {
  useGetDocumentsQuery,
  useGetTripDocumentsQuery,
  useGetStopDocumentsQuery,
  useAddDocumentMutation,
  useAddStopDocumentMutation,
  useUpdateDocumentMutation,
  useDeleteDocumetMutation,
} = documents;
